/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningHitClearanceState
 */
export interface ApiScreeningHitClearanceState {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningHitClearanceState
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningHitClearanceState
     */
    details: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningHitClearanceState
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiScreeningHitClearanceState
     */
    activatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiScreeningHitClearanceState
     */
    deactivatedAt?: Date;
}

/**
 * Check if a given object implements the ApiScreeningHitClearanceState interface.
 */
export function instanceOfApiScreeningHitClearanceState(value: object): value is ApiScreeningHitClearanceState {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('activatedAt' in value) || value['activatedAt'] === undefined) return false;
    return true;
}

export function ApiScreeningHitClearanceStateFromJSON(json: any): ApiScreeningHitClearanceState {
    return ApiScreeningHitClearanceStateFromJSONTyped(json, false);
}

export function ApiScreeningHitClearanceStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningHitClearanceState {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'details': json['details'],
        'content': json['content'],
        'activatedAt': (new Date(json['activatedAt'])),
        'deactivatedAt': json['deactivatedAt'] == null ? undefined : (new Date(json['deactivatedAt'])),
    };
}

export function ApiScreeningHitClearanceStateToJSON(json: any): ApiScreeningHitClearanceState {
    return ApiScreeningHitClearanceStateToJSONTyped(json, false);
}

export function ApiScreeningHitClearanceStateToJSONTyped(value?: ApiScreeningHitClearanceState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'details': value['details'],
        'content': value['content'],
        'activatedAt': value['activatedAt'].toISOString(),
        'deactivatedAt': value['deactivatedAt'] == null ? value['deactivatedAt'] : value['deactivatedAt'].toISOString(),
    };
}

